import { userlogin, userPhoneLogin } from '@/api/login'
import { refreshTokenIsUse } from 'util/auth'
var rs = require('jsrsasign')

export default {
  namespaced: true,
  state: {
    user: {}
  },
  getters: {
    userInfo (state, getters, rootState) {
      if (refreshTokenIsUse()) {
        let a = rootState.refreshToken.split('.')
        let uClaim = rs.b64utoutf8(a[1])
        let pClaim = rs.KJUR.jws.JWS.readSafeJSONString(uClaim)
        let date = new Date().getTime()
        if (date > pClaim.exp * 1000) {
          return state.user
        }
        return pClaim
      }
      return state.user
    }
  },
  mutations: {
  },
  actions: {
    login ({commit, state}, {username, password, code, UUID}) {
      return new Promise((resolve, reject) => {
        userlogin(username, password, code, UUID).then(function (response) {
          commit('setToken', {accessToken: response.data.access_token, refreshToken: response.data.refresh_token}, { root: true })
          state.user = response.data.user
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    loginphone ({commit, state}, {phone, phonecode, UUID}) {
      return new Promise((resolve, reject) => {
        userPhoneLogin(phone, phonecode, UUID).then(function (response) {
          commit('setToken', {accessToken: response.data.access_token, refreshToken: response.data.refresh_token}, { root: true })
          state.user = response.data.user
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    logOut ({commit}, {router}) {
      router.push({ path: '/' })
      commit('clearUser', null, { root: true })
    }
  }
}
